module.exports = __webpack_public_path__ + "admiracion.png?82d7beec2048090b980dc450afc6b635";


//////////////////
// WEBPACK FOOTER
// ./src/assets/admiracion.png
// module id = 634
// module chunks = 0 2 7 8 9 10 15 25 26